
import { TCompliantBlockRow } from "@/models/compliant_block";
import { Component, Prop, Vue } from "vue-property-decorator";

const ICONS = {
  checkmarkIcon: "checkmark-sharp",
  time: "time-outline",
  close: "close",
  help: "help-circle-outline",
};

const COMPLIANT_ROW_CLASS = "compliant-block__row";

const SUCCESS_TYPE = "success";
const ERROR_TYPE = "error";
const BLOCKED_TYPE = "blocked";
const SOON_TYPE = "soon";

@Component
export default class CompliantBlockRow extends Vue implements TCompliantBlockRow {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean }) checked!: boolean | null;
  @Prop({ type: Boolean }) comingSoon!: boolean | null;
  @Prop({ type: Boolean, default: false }) blocked!: boolean;

  icons = ICONS;

  get type() {
    if (this.blocked) return BLOCKED_TYPE;

    if (this.checked === null) return SOON_TYPE;

    if (this.checked && !this.comingSoon) return SUCCESS_TYPE;

    if (this.comingSoon) return SOON_TYPE;

    return ERROR_TYPE;
  }

  get isIconShown() {
    return !!this.type;
  }

  get iconName() {
    if (this.type === BLOCKED_TYPE) return "";

    if (!this.comingSoon) {
      if (this.type === SUCCESS_TYPE) return this.icons.checkmarkIcon;
    } else {
      if (this.type === SOON_TYPE) return this.icons.time;
    }
    if (this.type === ERROR_TYPE) return this.icons.close;

    // return this.icons.help;
    return "";
  }

  get classes() {
    const { type } = this;

    return {
      [`${COMPLIANT_ROW_CLASS}_${SUCCESS_TYPE}`]: type === SUCCESS_TYPE,
      [`${COMPLIANT_ROW_CLASS}_${ERROR_TYPE}`]: type === ERROR_TYPE,
      [`${COMPLIANT_ROW_CLASS}_${SOON_TYPE}`]: type === SOON_TYPE,
      [`${COMPLIANT_ROW_CLASS}_${BLOCKED_TYPE}`]: type === BLOCKED_TYPE,
    };
  }
}
